var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header-v'),_c('menuV'),_c('introV'),_c('portfolio',{attrs:{"msg":"Bienvenue sur ma page"}}),_c('contactV'),_c('footerV')],1)}
var staticRenderFns = []

export { render, staticRenderFns }